<template>
  <section class="canvas-draw-section">
    <canvas @mousedown="startPainting" @mouseup="finishedPainting" @mousemove="draw" id="canvas"></canvas>
    <div class="canvas-draw-btns">
      <button class="button" id="sig-clearBtn" @click.prevent="clear" v-if="!this.src && this.showCapture">
        Limpar
        <i class="fas fa-backspace"></i>
      </button>
      <button class="button" id="sig-clearBtn" @click.prevent="close">
        Cancelar
        <i class="far fa-times-circle"></i>
      </button>
      <button class="button" id="sig-submitBtn" @click.prevent="capture" v-if="!this.src && this.showCapture">
        Enviar
        <i class="fas fa-file-signature"></i>
      </button>
    </div>
    <div class="user-name-input-container" v-if="showNameInput">
      <label>Por favor preencha com seu nome:</label>
      <input type="text" v-model="_userName" @keydown.enter="submit" />
      <button class="button" @click.prevent="submit">OK</button>
    </div>
    <img class="sig-image" :src="src" alt="Sua assinatura" v-if="src" />
  </section>
</template>

<script>
export default {
  name: 'CanvasDraw',
  props: {
    userName: String,
  },
  data() {
    return {
      painting: false,
      canvas: null,
      ctx: null,
      src: '',
      showNameInput: false,
      showCapture: false,
    };
  },

  computed: {
    offsetY() {
      if (window.innerHeight > 460) return window.innerHeight - 380;
      else return 80;
    },
    _userName: {
      get() {
        return this.userName;
      },
      set(newValue) {
        this.$emit('update:userName', newValue);
      },
    },
  },
  methods: {
    startPainting(e) {
      this.painting = true;
      this.showCapture = true;
      // console.log(this.painting, e.clientX, e.clientY);
      this.draw(e);
    },
    finishedPainting(e) {
      this.painting = false;
      // console.log(this.painting, e.clientX, e.clientY);
      this.ctx.beginPath();
    },
    draw(e) {
      if (!this.painting) return;

      this.ctx.lineWidth = 4;
      this.ctx.lineCap = 'round';

      this.ctx.lineTo(e.clientX, e.clientY - this.offsetY);
      this.ctx.stroke();

      this.ctx.beginPath();
      this.ctx.moveTo(e.clientX, e.clientY - this.offsetY);
    },
    clear() {
      this.showCapture = false;
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.src = '';
    },
    capture() {
      let dataUrl = canvas.toDataURL();
      this.src = dataUrl;
      this.submit();
    },
    submit() {
      if (!this.userName) {
        this.showNameInput = true;
        // alert('Por favor preencha seu nome');
      } else this.$emit('submit', this.src);
    },
    close() {
      this.$emit('close', this.src);
    },
  },
  mounted() {
    this.canvas = document.getElementById('canvas');
    this.ctx = canvas.getContext('2d');

    // To-Do: Resize
    this.canvas.height = 200;
    this.canvas.width = window.innerWidth;

    this.canvas.style.marginTop = `${this.offsetY}px`;

    // Prevent scrolling when touching the canvas
    document.body.addEventListener(
      'touchstart',
      (e) => {
        if (e.target == this.canvas) {
          // e.preventDefault();
          // console.log('touchstart', { e });
          this.startPainting(e.changedTouches[0]);
        }
      },
      { passive: false },
    );
    document.body.addEventListener(
      'touchend',
      (e) => {
        if (e.target == this.canvas) {
          // e.preventDefault();
          // console.log('touchend', { e });
          this.finishedPainting(e.changedTouches[0]);
        }
      },
      { passive: false },
    );
    document.body.addEventListener(
      'touchmove',
      (e) => {
        if (e.target == this.canvas) {
          e.preventDefault();
          this.draw(e.changedTouches[0]);
        }
      },
      { passive: false },
    );
  },
};
</script>

<style lang="scss" scoped>
.canvas-draw-section {
  position: fixed;
  top: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  @include media('<=tablet') {
    position: fixed;
  }
}
canvas {
  width: calc(100vw - 20px);
  max-height: calc(100dvh - 20px);
  margin: 0 10px 10px;
  background: #eee;
  border: 3px solid #ddd;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.4);
}
.canvas-draw-btns {
  position: absolute;
  bottom: 14px;
  display: flex;
  gap: 10px;
  margin: 3px 0;
  z-index: 1;

  button {
    position: relative;
    // background: #ddd9;
    padding: 6px 10px;

    display: flex;
    align-items: center;
    i {
      margin-left: 8px;
    }
  }
}
.sig-image {
  position: absolute;
  bottom: 0px;
  background: #fff;
  width: calc(100vw - 20px);
  // max-height: 250px;
  border-radius: 10px;
  margin: 10px 10px;
}
.user-name-input-container {
  position: absolute;
  bottom: 0;
  min-height: calc(380px - 10vh);
  @include media('<=phone-plus') {
    min-height: 200px;
  }
  @media (max-height: 460px) {
    min-height: 200px;
  }
  width: 100%;
  z-index: 1;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background: #40404040;

  width: calc(100vw - 20px);
  max-height: calc(100dvh - 20px);
  margin: 0 10px 10px;
  @include media('<=phone') {
    margin: 0 10px 50px;
  }
  color: black;
  background: #eeeeee;
  border: 3px solid #ddd;
  border-radius: 10px;
  label {
    font-weight: bolder;
  }
  input {
    min-width: 260px;
    height: 30px;
    margin: 0 10px;
    padding: 0px 6px;
    color: black;
  }
  button {
    background: #ddd;
    padding: 12px 16px;
    color: black;
    font-weight: bolder;
    background: #ddde;
  }
}
#sig-submitBtn {
  padding: 12px 16px;
  color: black;
  font-weight: bolder;
  background: #ddde;
  border: 1px solid black;
  box-shadow: 0px 1px 6px 2px rgba(0, 0, 0, 0.4);
}
</style>
